import { render, staticRenderFns } from "./ResearchInnovationReviewerSave.vue?vue&type=template&id=61f65606&scoped=true&"
import script from "./ResearchInnovationReviewerSave.vue?vue&type=script&lang=js&"
export * from "./ResearchInnovationReviewerSave.vue?vue&type=script&lang=js&"
import style0 from "./ResearchInnovationReviewerSave.vue?vue&type=style&index=0&id=61f65606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f65606",
  null
  
)

export default component.exports